import { Fragment, memo, ReactElement } from 'react';
import ActiveStep from './active-step';
import AccordionPractice from './accordion-practice';
import AccordionApplicant from './accordion-applicant';
import AccordionAddress from './accordion-address';
import AccordionInterestedPeople from './accordion-interested-people';
import AccordionPracticeState from './accordion-practice-state';
import AccordionExceptionList from './accordion-exception-list';
import AccordionAccountholder from './accordion-accountholder';
import { PracticeDetailVM } from 'practice/view-models/practice-detail';
import AccordionAnnullament from 'practice/components/edit/form/step-annulment';
import { useFormikContext } from 'formik';
import { useParams } from 'react-router-dom';
import { typeRegisterAllowedDetail } from 'practice/constants/type-register-allowed-detail';
import { TypeRegister } from 'practice/constants/type-register';
import { PracticeData } from 'shell/models/practice';
import AccordionNotifications from './accordion-notifications';
import AccordionNotificationErrors from './accordion-notification-errors';

interface FormDetailProps {
  step?: number;
  isDetail?: boolean;
  redirectUriHistory?: boolean;
  loadViewMessi: () => Promise<void>;
  loadUpdateDate: () => Promise<PracticeDetailVM> | void;
  tipoIniziativa?: string;
  noteMesso?: string;
  datiMesso?: PracticeData;
}

const FormDetailComponent = ({
  step,
  isDetail,
  redirectUriHistory,
  loadViewMessi,
  loadUpdateDate,
  tipoIniziativa,
  noteMesso,
  datiMesso,
}: FormDetailProps): ReactElement => {
  const formContext = useFormikContext<PracticeDetailVM>();
  const params = useParams();

  const containsTypeRegister = typeRegisterAllowedDetail.includes(
    params.tipoRegistro as TypeRegister
  );

  return (
    <Fragment>
      <AccordionPractice disabled isDetail={isDetail} />
      <AccordionExceptionList />
      {!redirectUriHistory ? <AccordionApplicant disabled /> : <></>}
      <AccordionAccountholder disabled />
      {redirectUriHistory ? (
        containsTypeRegister ? (
          <AccordionAddress disabled />
        ) : (
          <></>
        )
      ) : (
        <AccordionAddress disabled />
      )}
      <AccordionPracticeState />
      <AccordionInterestedPeople disabled={isDetail} />
      <AccordionNotifications />
      <AccordionNotificationErrors />
      {Boolean(formContext.values.noteAnnullement) ? (
        <AccordionAnnullament
          disabled
          noteInitial={formContext.values.noteAnnullement}
          openInitail={false}
        />
      ) : undefined}
      <ActiveStep
        step={step}
        disabled={isDetail}
        loadViewMessi={loadViewMessi}
        loadUpdateDate={loadUpdateDate}
        tipoIniziativa={tipoIniziativa}
        noteMesso={noteMesso}
        datiMesso={datiMesso}
      />
    </Fragment>
  );
};

FormDetailComponent.displayName = 'Practice Detail - Form component';

const FormDetail = memo(FormDetailComponent);

export default FormDetail;
